const columns = [
  {
    title: "栏目",
    links: [
      { label: "现场热榜", href: "#topics" },
      { label: "直击现场", href: "#scene" },
      { label: "围观进行时", href: "#timeline" },
      { label: "围观守则", href: "#faq" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "平台说明", href: "#faq" },
      { label: "现场记录准则", href: "#faq" },
      { label: "信源与核实", href: "#faq" },
      { label: "商务合作", href: "#top" },
    ],
  },
];

const socials = ["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-bilibili-line", "ri-send-plane-line"];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      {/* CTA 收尾条 */}
      <div className="border-b border-background-200/70">
        <div className="shell flex flex-col items-center justify-between gap-5 py-12 text-center md:flex-row md:text-left">
          <div>
            <h2 className="font-serif text-xl font-bold text-foreground-950 md:text-2xl">
              别只隔着屏幕猜，一起看现场怎么说
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              追最新瓜点、围观现场聚集与群众反应，第一视角等你加入。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#scene"
              className="inline-flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-eye-line"></i>
              进入现场围观
            </a>
            <a
              href="#faq"
              className="inline-flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-camera-lens-line"></i>
              爆料现场
            </a>
          </div>
        </div>
      </div>

      {/* 厚壳主体 */}
      <div className="shell grid grid-cols-2 gap-8 py-12 md:grid-cols-12 md:py-14">
        <div className="col-span-2 md:col-span-5">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-eye-line text-lg"></i>
            </span>
            <span className="font-serif text-xl font-bold text-foreground-950">91群众</span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            围观现场直击、吃瓜看热闹第一视角。用图文记录现场聚集与群众反应，
            把每一份好奇心安放在可信的地方。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {socials.map((s, i) => (
              <a
                key={i}
                href="#top"
                aria-label="关注我们"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className={s}></i>
              </a>
            ))}
          </div>
        </div>

        {columns.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <h3 className="text-xs font-bold tracking-widest text-foreground-500">{c.title}</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {c.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-3">
          <h3 className="text-xs font-bold tracking-widest text-foreground-500">理性围观提示</h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            现场信息以核实为准。不造谣、不传谣、不泄露隐私，
            围观热闹也要守住边界。
          </p>
          <p className="mt-4 flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-record-circle-line text-accent-600"></i>
            现场记录持续更新中
          </p>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="shell flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <span>© 91群众 · 围观现场直击 · 图文记录</span>
          <span className="flex items-center gap-1.5">
            <i className="ri-verified-badge-line"></i>
            理性围观，不信谣不传谣
          </span>
        </div>
      </div>
    </footer>
  );
}